import FColumnCellMDP from '../FColumnCellMDP';
export default class FCellCreditorNameMDP implements FColumnCellMDP {
    
    dataSelectorKey: string | undefined;
    clientFileId: string | undefined
    target: string | undefined

    constructor({
        dataSelectorKey,
        clientFileId,
        target
    }: {  dataSelectorKey?: string, clientFileId?: string, target?: string }) {
        this.dataSelectorKey = dataSelectorKey;
        this.clientFileId = clientFileId;
        this.target = target
    }

    componentName: string = "FCellCreditorName";

    getMetaData(): object {
        return {
            componentName: this.componentName,
            props: {
                dataSelectorKey: this.dataSelectorKey,
                clientFileId: this.clientFileId,
                target: this.target
            }
        }
    }

}